import { render } from "./DashboardSlider.vue?vue&type=template&id=35c44c38&scoped=true"
import script from "./DashboardSlider.vue?vue&type=script&lang=js"
export * from "./DashboardSlider.vue?vue&type=script&lang=js"

import "./DashboardSlider.vue?vue&type=style&index=0&id=35c44c38&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c44c38"]])

export default __exports__